declare const jQuery: any;
const $ = jQuery;

export interface MouseWheelSettings
{
    onWheel: (direction: "up"|"down") => void;
    moveThreshold?: number; // pixels
    waitAfter?: number; // milliseconds
    stopPropagation?: boolean; // default true
    preventDefault?: boolean; // default true
}

export function listenForMouseWheel(settings: MouseWheelSettings, $el?: any)
{
    if ("ontouchstart" in window)
    {
        return { disable: (val: boolean) => {} };
    }
    const onWheel = settings.onWheel;
    const stopPropagation: boolean = (settings.stopPropagation === undefined) ? true : settings.stopPropagation;
    const preventDefault: boolean = (settings.preventDefault === undefined) ? true : settings.preventDefault;
    const moveThreshold: number = (settings.moveThreshold === undefined) ? 100 : settings.moveThreshold;
    const waitAfter: number = (settings.waitAfter === undefined) ? 900 : settings.waitAfter;
    $el = $($el || document.body);
    let disabled: boolean = false;
    let userDisabled: boolean = false;
    let y: number | undefined;
    let timer: any;
    let prevDeltaY: number | undefined;

    let waitingForScrollToEnd: boolean = false;
    let waitingForScrollToEndTimer: any;
    const waitingForScrollToEndInterval: number = 30; // milliseconds

    $el.on("wheel", function (event: any) {
        if (userDisabled) {
            return;
        }
        if (stopPropagation)
        {
            event.stopPropagation();
        }
        if (preventDefault)
        {
            event.preventDefault();
        }
        const deltaY: number = event.originalEvent.deltaY;
        if (deltaY === undefined)
        {
            return;
        }
        if ((prevDeltaY !== undefined) && ((prevDeltaY < 0 && deltaY >= 0) || (prevDeltaY >= 0 && deltaY < 0)))
        {
            // changed direction
            clearTimeout(timer);
            clearTimeout(waitingForScrollToEndTimer);
            disabled = false;
            waitingForScrollToEnd = false;
            prevDeltaY = deltaY;
            return;
        }
        prevDeltaY = deltaY;
        if (waitingForScrollToEnd)
        {
            clearTimeout(waitingForScrollToEndTimer);
            waitingForScrollToEndTimer = setTimeout(() => {
                waitingForScrollToEnd = false;
            }, waitingForScrollToEndInterval);
            return;
        }
        if (disabled)
        {
            return;
        }
        if (y === undefined)
        {
            y = deltaY;
            clearTimeout(timer);
        }
        else
        {
            y += deltaY;
        }
        if (y >= moveThreshold || y <= -moveThreshold)
        {
            // met threshold
            disabled = true;
            clearTimeout(timer);
            timer = setTimeout(() => {
                disabled = false;
            }, waitAfter);
            onWheel(y > 0 ? "up" : "down"); 
            y = undefined;
            prevDeltaY = undefined;
            waitingForScrollToEnd = true;
            waitingForScrollToEndTimer = setTimeout(() => {
                waitingForScrollToEnd = false;
            }, waitingForScrollToEndInterval);
        }
    });

    return {
        disable: (val: boolean) => {
            userDisabled = val;
        },
    };
}
